import * as _nodeFetch2 from "node-fetch";

var _nodeFetch = "default" in _nodeFetch2 ? _nodeFetch2.default : _nodeFetch2;

var exports = {};

var __awaiter = exports && exports.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = exports && exports.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HttpClient = void 0;

const node_fetch_1 = __importDefault(_nodeFetch);

class HttpClient {
  static send(request) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield (0, node_fetch_1.default)(request.getUrl(), request.getSendData());
    });
  }

}

exports.HttpClient = HttpClient; //# sourceMappingURL=HttpClient.js.map

export default exports;